module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("captchablock", [["div",{"class":"row capcha","id":"captchaBlock","style":"display: none"},[["span",{"id":"captcha","class":"capcha-img"}],["div",{"class":"mc-common-input icon captcha-wrapper"},[["input",{"type":"text","name":"captcha"}],["div",{"class":"label"},[["label",{"for":"name"},[["textNode",{"text":"Enter text"}]]]]]]],["div",{"class":"error-message"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/captcha.tpl
// module id = 1043
// module chunks = 4